var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("currency.title")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("currency.name") },
                    model: {
                      value: _vm.currency.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.currency, "Name", $$v)
                      },
                      expression: "currency.Name",
                    },
                  }),
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("currency.prefix") },
                    model: {
                      value: _vm.currency.Prefix,
                      callback: function ($$v) {
                        _vm.$set(_vm.currency, "Prefix", $$v)
                      },
                      expression: "currency.Prefix",
                    },
                  }),
                  _c("w-input-number", {
                    attrs: {
                      decimals: 7,
                      fancy: "",
                      label: _vm.$ct("currency.rate"),
                    },
                    model: {
                      value: _vm.currency.Rate,
                      callback: function ($$v) {
                        _vm.$set(_vm.currency, "Rate", $$v)
                      },
                      expression: "currency.Rate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("currency.title")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }